import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import mapValues from 'lodash/mapValues';
import xss from 'xss'

const whiteList = xss.getDefaultWhiteList();
whiteList.p.push('style');
whiteList.h2.push('style');
whiteList.h3.push('style');
whiteList.li.push('style');
const myxss = new xss.FilterXSS({
  whiteList,
  css: false,
});

const sanitize = data => {
  if (isArray(data)) return data.map(sanitize)
  if (isObject(data)) return mapValues(data, sanitize)
  return myxss.process(data)
}

export default sanitize
